// Minimal feature-flag helper. Flags are read from build-time env vars
// (VUE_APP_* per the app's .env.[mode] convention) and default to OFF
// unless a mode file explicitly sets them to "true".

export function isAutomatedReorderEnabled() {
  return process.env.VUE_APP_FEATURE_AUTOMATED_REORDER === "true";
}
